import { render, staticRenderFns } from "./ColorModuleSearch.vue?vue&type=template&id=6545cde8&scoped=true"
import script from "./ColorModuleSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleSearch.vue?vue&type=style&index=0&id=6545cde8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545cde8",
  null
  
)

export default component.exports